module.exports = __webpack_public_path__ + "static/img/6.bb80bc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/6.png
// module id = RkIA
// module chunks = 0